import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  SUPPORTED_LANGUAGES,
  changeLanguage,
  normalizeLanguage,
} from "../i18n";

/**
 * Текущий язык в двухбуквенном виде + синхронизация с атрибутом <html lang>,
 * который важен для скринридеров и поисковых систем.
 */
export function useLanguage() {
  const { i18n } = useTranslation();
  const language = normalizeLanguage(i18n.resolvedLanguage || i18n.language);

  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);

  return {
    language,
    languages: SUPPORTED_LANGUAGES,
    changeLanguage,
  };
}

export { SUPPORTED_LANGUAGES };
export default useLanguage;
